



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ELTABLE_FORMAT } from '@/utils/elTable_formatter';
import { ADJUSTMENT_MAP } from '@/const/options/index';
import {ADJUSTMENT_TYPE} from '@/const/types/adjustment';

interface PriceTypeFilter {
    text: string;
    value: string;
}

@Component<PriceColumn>({
    name: 'PriceColumn',
})
export default class PriceColumn extends Vue {
    private formatter: (row: any, column: any) => string = ELTABLE_FORMAT.NumberFormat;
    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'right' }) private align!: string;
    @Prop({ type: [String, Number], default: 180 }) private width!: number | string;
    @Prop({ type: [String, Number], default: 180 }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;

    @Prop({ type: String, default: 'price' }) private price!: string;
    @Prop({ type: String, default: 'type' }) private type!: string;
    @Prop({ type: String, default: 'value' }) private value!: string;
    private ADJUSTMENT_MAP = ADJUSTMENT_MAP;
    // private filters: PriceTypeFilter[] = [
    //     {
    //         text: ADJUSTMENT.CPM,
    //         value: ADJUSTMENT.CPM,
    //     },
    //     {
    //         text: ADJUSTMENT.CPC,
    //         value: ADJUSTMENT.CPC,
    //     },
    // ];

    // private filterHandler(value: string, row: any, column: any) {
    //     const v = row[this.price][this.type];
    //     console.log(value, row, v)
    //     return v === value;
    // }
}
